export const environment = {
  production: false,
  apiUrl: 'https://dev-gate-api.uims.kz/api/',
  finesUrl: 'https://dev-gate-api.uims.kz/api/',
  cameraStreamUrl: 'https://dev-gate-camera-stream.uims.kz',
};
